<div class="content">
  <!-- Header section -->
  <div class="header_area ng-star-inserted d-flex justify-content-center">
    <a routerLink="/landing" target="_blank">
      <img src="/assets/images/familycentral-logo.svg" alt="Family Central" class="logo_img" width="150" height="150" />
    </a>
  </div>

  <!--Dashboard content Starts Here-->
  <div class="dashboard_content">
    <div class="upload_content_wrapper">
      <!--This is for Upload text code-->
      <div class="Upload_text">
        <h3>Upload and send a file<br> in 2 easy steps</h3>
        <ul>
          <li class="d-flex">
            <span>1. Click the Upload icon to select <br class="rwd-line" />a
            file from your computer or device.</span>
          </li>
          <li class="d-flex">
            <span>2. Click the Send button to <br class="rwd-line" />deliver the
            file to your client.</span>
          </li>
        </ul>
      </div>

      <div class="uploadndSend_form">
        <h4 class="onboarding-heading mb-2">Upload & Send</h4>
        <div>
          @if (!fileUploaded) {
            <p class="onboarding-subheading mb-4">
              Click the Upload icon to select a file.
            </p>
          }
          @if (fileUploaded) {
            <div>
              <p class="onboarding-subheading mb-2"><b>File Uploaded</b></p>
            </div>
          }

          <div>
            <div class="form-group input_file my-4" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
              (drop)="onDrop($event)">
              <input type="file" name="retake-profile" id="retake-profile" (change)="OnFileChange($event)" #fileInput>
              <label for="retake-profile" class="input_file_label">
                <img src="/assets/images/upload-icon.svg" width="40" height="40" alt="" class="d-block mx-auto mb-1">
                <span>Select a file to upload</span>
              </label>
            </div>
          </div>

          <p class="onboarding-subheading">{{ file?.name }}</p>

          <!--This is for buttons-->
          <div class="upload_btn form-group d-flex justify-content-between align-items-center">
            <button type="button" class="border_btn" data-bs-dismiss="modal" (click)="onClose()">
              Cancel
            </button>
            <div class="group-btn">
              @if (file?.name) {
                <button type="button" class="border_btn me-2" (click)="file = null">
                  Delete
                </button>
              }
              <button [disabled]="!file" type="button" class="primary_btn" (click)="onSave()">
                Send
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>